import type { MotionNodeAnimationOptions } from 'motion/react';
import { type Ref } from 'react';
import { Stage } from './stage';

export const ToggleStage = <T,>({
  status,
  fallback,
  children,
  className,
  options,
  data,
  ref,
}: {
  status: boolean;
  fallback?: React.ReactNode;
  children: React.ReactNode | ((data: NonNullable<T>) => React.ReactNode);
  className?: string;
  options?: MotionNodeAnimationOptions;
  data?: T;
  ref?: Ref<HTMLDivElement>;
}) => {
  return (
    <Stage>
      <Stage.Scene status={!status} className={className}>
        {fallback}
      </Stage.Scene>
      <Stage.Scene default className={className} options={options} ref={ref}>
        {typeof children === 'function' ? (data ? children(data) : null) : children}
      </Stage.Scene>
    </Stage>
  );
};
